import Axios from "axios";

export default {
    getUses(itemId, params) {
        return Axios.get(`${process.env.BARRAMUNDI}inventory/uses/${itemId}`, {
            params
        }).then(res => {
            if (res.data && res.data.response && res.data.response.resources) {
                return res.data.response.resources;
            }
            return [];
        });
    },
    async getUsesCount(itemId) {
        const res = await Axios.get(
            `${process.env.BARRAMUNDI}inventory/uses/${itemId}/count`
        );
        if (
            res &&
            res.data &&
            res.data.response &&
            res.data.response.resource != undefined
        ) {
            return res.data.response.resource;
        }
        return null; // if null, show error message
    },
    deleteUse(useId) {
        return Axios.delete(
            `${process.env.BARRAMUNDI}inventory/uses/${useId}`
        ).then(response => response.data);
    },
    async newUse(params) {
        let res = await Axios.post(
            `${process.env.BARRAMUNDI}inventory/uses`,
            params
        );
        if (res.data && res.data.response) {
            return res.data.response;
        } else {
            return null;
        }
    },
    async updateUse(useId, params) {
        let res = await Axios.put(
            `${process.env.BARRAMUNDI}inventory/uses/${useId}`,
            params
        );
        if (res.data && res.data.response) {
            return res.data.response;
        } else {
            return null;
        }
    }
};
